
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2FMc9", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagActionDropdownSimple", () => $8dfde15e790b5286$export$13c650f5e4062632);
$parcel$export(module.exports, "default", () => $8dfde15e790b5286$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $44qT7 = parcelRequire("44qT7");
var $aOrxC = parcelRequire("aOrxC");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $bngFq = parcelRequire("bngFq");

var $d5g7Q = parcelRequire("d5g7Q");
const $8dfde15e790b5286$var$gridSize = 8;
const $8dfde15e790b5286$var$styles = {
    featureFlagDropdownScrollContainer: "_1reo1wug _18m91wug _c71l10bg",
    featureFlagDropdownWidthContainer: "_p12f1feq",
    linkItemStyles: "_oiqe1wug"
};
const $8dfde15e790b5286$var$FeatureFlagActionDropdownInner = ({ connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget, onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger, hideConnectFeatureFlagLinks: hideConnectFeatureFlagLinks = false, hideCreateFeatureFlagLinks: hideCreateFeatureFlagLinks = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const previousOpen = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (previousOpen.current !== isOpen) {
            previousOpen.current = isOpen;
            isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'featureFlagActionDropdown');
            !isOpen && (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'featureFlagActionDropdown');
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        isOpen,
        onOpenDropdown
    ]);
    const createFeatureFlagDropdownItem = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $8dfde15e790b5286$var$styles.featureFlagDropdownScrollContainer
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        ), {
            key: createFeatureFlagTarget,
            href: createFeatureFlagTarget,
            onClick: ()=>{
                setIsOpen(false);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'CreateFeatureFlagLink', {
                    redirectToFFProviderPage: true
                });
            },
            target: "_blank",
            rel: "noreferrer noopener",
            testId: "development-summary-feature-flag.common.ui.feature-flag-action-dropdown-simple.link-item",
            className: (0, $bwpsq.default)([
                $8dfde15e790b5286$var$styles.linkItemStyles
            ])
        }, formatMessage((0, $d5g7Q.default).createFeatureFlagMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
            action: "shown",
            actionSubject: "createFeatureFlagLinkList"
        })), [
        createFeatureFlagTarget,
        formatMessage,
        createAnalyticsEvent
    ]);
    const showCreateFeatureFlagLinkSection = !hideCreateFeatureFlagLinks && createFeatureFlagTarget !== null && createFeatureFlagTarget !== undefined;
    const connectFeatureFlagDropdownItem = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $8dfde15e790b5286$var$styles.featureFlagDropdownScrollContainer
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44qT7.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        ), {
            key: connectFeatureFlagTarget,
            href: connectFeatureFlagTarget,
            onClick: ()=>{
                setIsOpen(false);
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'ConnectFeatureFlagLink', {
                    redirectToFFProviderPage: true
                });
            },
            target: "_blank",
            rel: "noreferrer noopener",
            testId: "development-summary-feature-flag.common.ui.feature-flag-action-dropdown-simple.link-item",
            className: (0, $bwpsq.default)([
                $8dfde15e790b5286$var$styles.linkItemStyles
            ])
        }, formatMessage((0, $d5g7Q.default).connectFeatureFlagMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
            action: "shown",
            actionSubject: "connectFeatureFlagLinkList"
        })), [
        connectFeatureFlagTarget,
        formatMessage,
        createAnalyticsEvent
    ]);
    const showConnectFeatureFlagLinkSection = !hideConnectFeatureFlagLinks && connectFeatureFlagTarget !== null && connectFeatureFlagTarget !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        id: "feature-flag-action-dropdown",
        testId: "development-summary-feature-flag.common.ui.feature-flag-action-dropdown-simple.popup",
        zIndex: (0, $gwIPs.layers).modal + 1,
        placement: "bottom-end",
        messageId: "development-summary-feature-flag.common.ui.feature-flag-action-dropdown-simple.popup",
        messageType: "transactional",
        shouldFlip: true,
        trigger: (triggerProps)=>getDropdownTrigger({
                ...triggerProps,
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen)
            }),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    $8dfde15e790b5286$var$styles.featureFlagDropdownWidthContainer
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOrxC.default), null, showCreateFeatureFlagLinkSection && createFeatureFlagDropdownItem, showConnectFeatureFlagLinkSection && connectFeatureFlagDropdownItem))
    });
};
const $8dfde15e790b5286$export$13c650f5e4062632 = ({ connectFeatureFlagTarget: connectFeatureFlagTarget, createFeatureFlagTarget: createFeatureFlagTarget, onOpenDropdown: onOpenDropdown, getDropdownTrigger: getDropdownTrigger, hideConnectFeatureFlagLinks: hideConnectFeatureFlagLinks = false, hideCreateFeatureFlagLinks: hideCreateFeatureFlagLinks = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            singleFFProvider: connectFeatureFlagTarget != null && connectFeatureFlagTarget !== undefined || createFeatureFlagTarget != null && createFeatureFlagTarget !== undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8dfde15e790b5286$var$FeatureFlagActionDropdownInner, {
        connectFeatureFlagTarget: connectFeatureFlagTarget,
        createFeatureFlagTarget: createFeatureFlagTarget,
        onOpenDropdown: onOpenDropdown,
        getDropdownTrigger: getDropdownTrigger,
        hideConnectFeatureFlagLinks: hideConnectFeatureFlagLinks,
        hideCreateFeatureFlagLinks: hideCreateFeatureFlagLinks
    }));
var $8dfde15e790b5286$export$2e2bcd8739ae039 = $8dfde15e790b5286$export$13c650f5e4062632;

});
parcelRegister("d5g7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd9ed38661b9331f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dd9ed38661b9331f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createFeatureFlagMessage: {
        "id": "development-summary-feature-flag.common.feature-flag-action-dropdown-simple.create-feature-flag-message",
        "defaultMessage": "Create feature flag"
    },
    connectFeatureFlagMessage: {
        "id": "development-summary-feature-flag.common.feature-flag-action-dropdown-simple.connect-feature-flag-message",
        "defaultMessage": "Connect feature flag"
    },
    sectionTitle: {
        "id": "development-summary-feature-flag.common.feature-flag-action-dropdown-simple.section-title",
        "defaultMessage": "Actions"
    }
});

});



//# sourceMappingURL=feature-flag-action-dropdown-simple.8dc76c16.js.map
